import EditVacancyContainer from "../containers/EditVacancyContainer";

const EditVacancyPage = () => {
  return (
    <EditVacancyContainer />
  );
};

export default EditVacancyPage;
